import { render, staticRenderFns } from "./EquipmentDetails.vue?vue&type=template&id=4c2ccfc3&scoped=true"
import script from "./EquipmentDetails.vue?vue&type=script&lang=js"
export * from "./EquipmentDetails.vue?vue&type=script&lang=js"
import style0 from "./EquipmentDetails.vue?vue&type=style&index=0&id=4c2ccfc3&prod&scoped=true&lang=less"
import style1 from "./EquipmentDetails.vue?vue&type=style&index=1&id=4c2ccfc3&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c2ccfc3",
  null
  
)

export default component.exports